import { BFF_HARDENING_KEY, HARNESS_FLAGS } from './harnessFlags';

let factory: SplitIO.IBrowserSDK | null = null;

export const setBrowserHarnessFactory = (
  nextFactory: SplitIO.IBrowserSDK | null,
) => {
  factory = nextFactory;
  // Creating the keyed client starts its sync, so the flag is ready by the
  // first verification request.
  try {
    factory?.client(BFF_HARDENING_KEY);
  } catch {
    // Treated as off below.
  }
};

export const isBrowserHarnessFlagOn = (
  flagKey: string,
  splitKey?: string | null,
): boolean => {
  if (!factory || !splitKey) return false;
  try {
    return factory.client(splitKey).getTreatment(flagKey) === 'on';
  } catch {
    return false;
  }
};

export const isBffHardeningOn = (): boolean =>
  isBrowserHarnessFlagOn(HARNESS_FLAGS.BFF_HARDENING, BFF_HARDENING_KEY);
